const CODE_ALIASES = {
  SRV000010: "200050", // Pieza Erupcionada
  SRV000011: "200055", // Pieza Semiretenida
  SRV000012: "930005", // Rx Periapical
  SRV000013: "930001", // Rx Panorámica
  SRV000024: "200130", // Ajuste Oclusal
  SRV000025: "200135", // Placa Miorrelajante
  SRV000043: "200333", // Desvitalización y Momificación
  SRV000044: "200110", // Colgajo
  SRV000049: "200378", // Limpieza Quirúrgica
};

const DESCRIPTION_ALIASES = {
  "PIEZA ERUPCIONADA": "200050",
  "PIEZA SEMIRETENIDA": "200055",
  "RX PERIAPICAL": "930005",
  "RX PANORÁMICA": "930001",
  "RX PANORAMICA": "930001",
  "AJUSTE OCLUSAL": "200130",
  "PLACA MIORRELAJANTE": "200135",
  "DESVITALIZACIÓN Y MOMIFICACIÓN": "200333",
  "DESVITALIZACION Y MOMIFICACION": "200333",
  "COLGAJO": "200110",
  "LIMPIEZA QUIRÚRGICA": "200378",
  "LIMPIEZA QUIRURGICA": "200378",
};

export const normalizeProcedimientoCode = (codigo = "", descripcion = "") => {
  const code = codigo.toString().trim().toUpperCase();
  const desc = descripcion.toString().trim().toUpperCase();

  if (CODE_ALIASES[code]) return CODE_ALIASES[code];
  if (DESCRIPTION_ALIASES[desc]) return DESCRIPTION_ALIASES[desc];

  return code;
};

export default normalizeProcedimientoCode;
